<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <a-button
      type="primary"
      :style="{ margin: '0 0 24px 0' }"
      v-on:click="showModal"
    >
      新增
    </a-button>
    <a-modal
      v-model="visible"
      title="编辑分类"
      @ok="handleok"
      cancelText="取消"
      okText="确定"
    >
      <a-form-model
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-form-model-item label="分类名称">
          <a-input
            v-model="formInline.projectName"
            placeholder="请输入分类名称"
          >
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      v-model="visibletwo"
      title="添加分类"
      @ok="handleoktwo"
      cancelText="取消"
      okText="确定"
    >
      <a-form-model
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-form-model-item label="分类名称">
          <a-input
            v-model="formInlinetwo.projectNametwo"
            placeholder="请输入分类名称"
          >
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(item) => item.objId"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="middle"
    >
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="editbtn(operate)">编辑</a>
        <a href="javascript:;" @click="delbtn(operate)">删除</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  projectpagingdata,
  projectUpdate,
  projectAdd,
  projectDel,
} from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "objId",
    sorter: true,
    width: "10%",
    scopedSlots: { customRender: "objId" },
  },
  {
    title: "项目名称",
    dataIndex: "projectName",
    width: "8%",
    scopedSlots: { customRender: "projectName" },
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
    width: "15%",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    width: "15%",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      formInline: {
        projectName: "",
      },
      formInlinetwo: {
        projectNametwo: "",
      },
      projectId: "",
      visible: false,
      visibletwo: false,
      loading: false,
      columns,
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
    };
  },
  mounted() {
    // this.fetch()
    this.getProjectPagingData();
  },
  methods: {
    // 分页按钮
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      projectpagingdata({ limit: 10, page: this.pagination.current }).then(
        (res) => {
          this.data = res.data;
          console.log(res);
          this.loading = false;
        }
      );
    },
    // 编辑
    handleok() {
      // 编辑
      projectUpdate({
        id: this.projectId,
        projectName: this.formInline.projectName,
      }).then(() => {
        message.success("编辑成功");
        this.getProjectPagingData();
      });
      this.formInline = {
        projectName: "",
      };
      this.visible = false;
    },
    // 新增
    handleoktwo() {
      if (this.formInlinetwo.projectNametwo === "") {
        message.warning("名称不能为空");
      } else {
        projectAdd({
          projectName: this.formInlinetwo.projectNametwo,
        }).then((res) => {
          message.success(res.data);
          this.getProjectPagingData();
        });
      }
      this.formInlinetwo = {
        projectNametwo: "", // 输入的分类名称
      };
      this.visibletwo = false;
    },
    showModal() {
      this.visibletwo = true;
    },
    handleSubmit() {},
    getProjectPagingData() {
      projectpagingdata({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    // 编辑
    editbtn(row) {
      console.log(row);
      this.visible = true;
      this.projectId = row.objId;
      this.formInline.projectName = row.projectName;
    },
    // 删除
    delbtn(row) {
      console.log(row);
      projectDel(row.objId).then(() => {
        message.success(res.data);
        this.getProjectPagingData();
      });
    },
    // fetch(params = {}) {
    //   this.loading = true;
    //   queryData({
    //     results: 10,
    //     ...params,
    //   }).then(({ data }) => {
    //     const pagination = { ...this.pagination };
    //     // Read total count from server
    //     // pagination.total = data.totalCount;
    //     pagination.total = 200;
    //     this.loading = false;
    //     this.data = data.results;
    //     this.pagination = pagination;
    //   });
    // },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/marketingManagement/projectManagement.vue